import { GetUserPendenciesPayload } from '@plug/domains/organization/graphql/queries/get-user-pendencies';

export const getBraspagBankStatus = (payload: GetUserPendenciesPayload['getUserPendencies']) => {
  return payload
    ?.find(item => item.pendency === 'Braspag')
    ?.metadata?.find(item => item.key === 'braspagBankStatus')
    ?.value?.replace(/[^\d.-]+/g, '');
};
